const { inflateSpa } = require('utils/framework/InflateSPA');
const CookieActions = require('../../actions/CookieActions');
const History = require('../../services/History');
const Store = require('../../store/Store');
const cookieUtils = require('utils/Cookies');
const gpc = require('utils/gpc');
const Location = require('utils/Location');


const initializeApplication = () => {
    // make sure DOM is ready
    if (Sephora.DOMContentLoadedFired) {
        renderRootComponents();
    } else {
        window.addEventListener('DOMContentLoaded', renderRootComponents);
    }
};

/**
 * GPC compliance in this case is reading a globalPrivacyControl from the navigator
 * and sync it with the gpc cookie. If flag turns to true - set a cookie, remove 1st party
 * cookies except allowed and reload the page
 * @returns {void}
 */
const complyGPC = () => {
    // Reaction to the GPC (https://jira.sephora.com/browse/UTS-2841)
    const userAgentGPCFlag = window.navigator.globalPrivacyControl || false;
    const gpcCookie = cookieUtils.read(cookieUtils.KEYS.GPC);

    if (userAgentGPCFlag && gpcCookie !== '1') {
        gpc.deleteAllCookiesExceptAllowed();
        cookieUtils.write(cookieUtils.KEYS.GPC, 1);

        Location.reload();
    } else if (!userAgentGPCFlag && gpcCookie) {
        cookieUtils.delete(cookieUtils.KEYS.GPC);
    }
};

const renderRootComponents = () => {
    complyGPC();
    Store.initialize();
    inflateSpa()
        .then(doPostHydrationInitialization)
        // eslint-disable-next-line no-console
        .catch(error => error && console.log(JSON.stringify(error)));
};

// To avoid store mutations before hydration process has finished its work we need to do all store updates only
// after first render circle because it's mandatory to render same HTML markup as it was after SSR
// Do all initialization store mutations from here because this function is invoked right after hydration
const doPostHydrationInitialization = () => {
    Store.onHydrationFinished();
    History.initFrontEndRouter();
    Store.dispatch(CookieActions.setAllCookies(Sephora.Util.InflatorComps.pageLoadCookies));
};

module.exports = { initializeApplication };
